const formatDate = (datestring) => {
    const pattern = /[0-9]{4}-[0-9]{2}-[0-9]{2}/;
    const dateResult = pattern.exec(datestring.toString());

    return dateResult[0] || '';
};

export default formatDate;
